<template>
  <div class="video" :style="{ opacity: opacity }">
    <div class="play">
      <!--  包裹video的盒子 @touchstart="touchEnterVideo"
        @touchend="touchLeaveVideo" -->
      <div
        ref="myvideos"
        :style="{ height: fullHeight * 0.87 + 'px' }"
        class="myvideo"
        :class="fullScreenState ? 'fullscreen' : ''"
        @click="touchClick(controlerShow)"
        @touchmove="touchMoveAction($event)"
      >
        <video
          ref="myvideo"
          :class="[widthFix ? 'widthFix' : 'heightFix']"
          :muted="mutedState"
          :src="videoInfo.productUrl"
          :poster="videoInfo.iconUrl"
          preload="load"
          @canplay="getTotal"
          @stalled="isLoading = true"
          @error="handleError"
          @waiting="handleWaiting"
          @canplaythrough="canplaythrough"
        >
          <source :src="videoInfo.productUrl" type="video/mpg" />
        </video>
        <div class="videoPlay">
          <!-- 时间进度条 -->
          <div class="myprogress" v-if="this.controlerShow">
            <barprogress
              v-model="currentTimeValue"
              :loaded="loaded"
              :screenWidth="screenWidth"
              @input="changeProgressAction"
              @touch="handleTouchAction"
              @clickIpt="handleClickAction"
            ></barprogress>
          </div>
          <!-- 自定义的controls -->
          <div class="controls" v-show="this.controlerShow">
            <div class="left">
              <div class="playState" @click.stop="play()">
                <img
                  class="player"
                  v-if="isPaused"
                  src="../assets/icon_bf.png"
                  alt=""
                />
                <img
                  class="player"
                  v-if="!isPaused"
                  src="../assets/icon_zt.png"
                  alt=""
                />
              </div>
              <div class="bofang">
                <img
                  src="../assets/icon_lb.png"
                  v-if="volume === 0 ? false : true"
                  @click.stop="getVolume()"
                  alt=""
                />
                <img
                  src="../assets/icon_jy.png"
                  v-if="volume === 0 ? true : false"
                  @click.stop="getVolume()"
                  alt=""
                />
                <!-- 音量进度条 -->
                <div class="block" v-show="voiceProgressShow">
                  <div class="box">{{ volume }}</div>
                  <el-slider
                    v-model="volume"
                    height="100px"
                    vertical
                    :show-tooltip="false"
                    @change="getNewVoice(volume)"
                  ></el-slider>
                </div>
              </div>
              <span class="time">{{ currentTime }} / {{ totalTime }}</span>
            </div>
            <div class="right">
              <img
                src="../assets/icon_qp.png"
                @click.stop="toggleFullScreen()"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- 加载标签 -->
        <div class="loading">
          <div class="loader" v-show="isLoading">
            <div class="loader-inner ball-clip-rotate">
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div class="opacityBtn" :style="{ height: fullHeight * 0.13 + 'px' }">
        <div class="text">不透明度</div>
        <div class="slider">
          <opacityprogress
            v-model="opacity"
            :screenWidth="screenWidth"
            @input="changeOpacityProgressAction"
          ></opacityprogress>
        </div>
        <div class="opacityValue">{{ Number(opacity * 100).toFixed(0) }}%</div>
      </div>
    </div>
  </div>
</template>
<script>
import barprogress from '../components/progress/barprogress.vue'
import opacityprogress from '../components/progress/opacity.vue'
export default {
  components: {
    barprogress,
    opacityprogress
  },
  data: () => ({
    // 不透明度
    opacity: 1,
    timer: null,
    fullHeight: document.documentElement.clientHeight,
    screenWidth: document.body.clientWidth,
    // 自动播放
    // autoplay: true,
    // 是否静音
    mutedState: false,
    isLoading: false,
    // 横屏充满
    widthFix: true,
    // 播放状态
    isPaused: false,
    // 当前时间
    currentTime: '00:00',
    // 总时间
    totalTime: '00:00', // 总时长,
    // 音量
    volume: 30,
    // 进度条当前播放时间，必须是number类型
    currentTimeVal: 0,
    currentTimeValue: 0,
    // 进度条的最大值，必须是number类型
    durationProgress: 0,
    // 是否展示音量进度条
    voiceProgressShow: false,
    // 是否全屏
    fullScreenState: false,
    // 进度条和控制按钮显示隐藏
    controlerShow: true,
    // 进度条延时器
    controlerShowTimer: '',
    // 音量进度条延时器
    voiceProgressShowTimer: '',
    // 拖动进度条时
    setDrag: false,
    // 缓存长度
    loaded: 0,
    // 是否是首次触碰屏幕
    firstTouch: true,
    isError: false,

    // 模拟视频数据
    videoInfo: {
    }
  }),
  methods: {
    // 点击屏幕显示隐藏controls
    touchClick (show) {
      this.controlerShow = !show
      const that = this
      clearInterval(this.controlerShowTimer)
      this.controlerShowTimer = setTimeout(function () {
        that.controlerShow = false
      }, 5000)
    },
    // 在屏幕上滑动时
    touchMoveAction (e) {
      this.controlerShow = true
      const that = this
      clearInterval(this.controlerShowTimer)
      this.controlerShowTimer = setTimeout(function () {
        that.controlerShow = false
      }, 5000)
    },
    // 不透明度
    getOpacity (value) {
      console.log(value);
    },
    // 等待数据加载
    handleWaiting () {
      this.controlerShow = true;
      this.isLoading = true;
    },
    canplaythrough (e) {
      // this.controlerShow = false
      this.isLoading = false;
    },
    // 数据加载出错
    handleError () {
      this.isError = true;
    },
    // 触碰播放区
    // touchEnterVideo () {
    //   if (this.firstTouch) return;
    //   if (this.controlerShowTimer) {
    //     clearTimeout(this.controlerShowTimer);
    //     this.hideTimer = null;
    //   }
    //   this.controlerShow = true;
    // },
    // // 离开播放区
    // touchLeaveVideo () {
    //   if (this.firstTouch) return;
    //   if (this.controlerShowTimer) {
    //     clearTimeout(this.controlerShowTimer);
    //   }
    //   this.controlerShowTimer = setTimeout(() => {
    //     this.controlerShow = false
    //     this.hideTimer = null;
    //   }, 5000);
    // },
    // 更新进度条时间
    getNewTime (val) {
      this.myvideo.currentTime = parseInt(val)
    },
    // 更新进度条时间
    changeProgressAction (value) {
      this.currentTimeVal = (value / this.durationProgress)
      this.myvideo.currentTime = (value * this.durationProgress)
    },
    // 拖拽进度条
    handleTouchAction (isTouch) {
      this.setDrag = isTouch
    },
    // 点击进度条时，controls设置为true
    handleClickAction (isClick) {
      this.controlerShow = true
      clearTimeout(this.controlerShowTimer)
      this.controlerShowTimer = setTimeout(() => {
        this.controlerShow = false
      }, 5000)
    },
    // 是否展示音量进度条
    getVolume () {
      this.voiceProgressShow = !this.voiceProgressShow
      clearTimeout(this.voiceProgressShowTimer)
      this.voiceProgressShowTimer = setTimeout(() => {
        this.voiceProgressShow = false
      }, 3000)
      clearTimeout(this.controlerShowTimer)
      this.controlerShowTimer = setTimeout(() => {
        this.controlerShow = false
      }, 5000)
    },
    // 调节视频音量大小
    getNewVoice (val) {
      this.volume = val
      const newVc = val / 100 // h5规定,volume的值必须再0-1之间,比如0.5就是50%的音量,但是进度条的值为100,因此这里做个除法
      this.myvideo.volume = newVc // 赋值
      clearTimeout(this.voiceProgressShowTimer)
      this.voiceProgressShowTimer = setTimeout(() => {
        this.voiceProgressShow = false
      }, 3000)
      clearTimeout(this.controlerShowTimer)
      this.controlerShowTimer = setTimeout(() => {
        this.controlerShow = false
      }, 5000)
    },
    // 获取当前视频播放到的时间
    timeupdate () {
      if (this.myvideo.currentTime === this.myvideo.duration) {
        this.isPaused = !this.isPaused
        this.myvideo.pause()
      }
      if (this.setDrag) {
        return;
      }
      this.currentTime = this.timeFormat(this.myvideo.currentTime)
      this.currentTimeValue = this.myvideo.currentTime / this.myvideo.duration
    },
    // 视频播放状态
    play () {
      // 将首次触碰值改为false
      this.firstTouch = false
      // 修改当前 的播放状态
      this.isPaused = !this.isPaused
      if (this.isPaused) {
        this.myvideo.play()
        this.isLoading = false
        this.myvideo.addEventListener("timeupdate", this.timeupdate)
        // 监听缓存进度
        this.myvideo.addEventListener("progress", e => {
          this.getLoadTime();
        });
        this.controlerShow = true
        clearTimeout(this.controlerShowTimer)
        this.controlerShowTimer = setTimeout(() => {
          if (this.isPaused) {
            this.controlerShow = false
            this.voiceProgressShow = false
          }
        }, 5000)
      } else {
        this.myvideo.pause()
      }
    },
    // 时间格式化处理
    timeFormat (time) {
      let minute = Math.floor((time % 3600) / 60)
      let second = Math.floor(time % 60)
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second
      return `${minute}:${second}`
    },
    // 获取总时长
    getTotal () {
      this.totalTime = this.timeFormat(this.myvideo.duration)
      this.durationProgress = this.myvideo.duration
    },
    toggleFullScreen () { // 切换全屏
      //this.fullScreenState = !this.fullScreenState;
      if (this.isFullScreen()) {
        this.exitFullscreen()
      } else {
        this.requestFullscreen(document.querySelector('.myvideo'));
      }
    },
    isFullScreen () {
      return document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen
    },
    requestFullscreen (ele) {
      // 全屏兼容代码
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
      this.fullScreenState = true;
      this.controlerShow = false;
      this.firstTouch = false;
    },
    // 取消全屏
    exitFullscreen () {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      }
      this.fullScreenState = false
      this.controlerShow = false
    },
    // 获取缓存时间
    getLoadTime () {
      this.loaded =
        (this.myvideo.buffered.end(0) / this.myvideo.duration) * 100;
    },
    // 更新不透明度
    changeOpacityProgressAction (value) {
      if (value <= 0.05) {
        value = 0.05
      }
      this.opacity = Number(value).toFixed(2)
    },
  },
  created () {
    this.videoInfo.productUrl = JSON.parse(localStorage.getItem('productUrl'))
    this.videoInfo.iconUrl = JSON.parse(localStorage.getItem('iconUrl'))
  },
  mounted () {
    // 获取播放器元素
    this.myvideo = this.$refs.myvideo
    const that = this
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight
        that.fullHeight = window.fullHeight
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })()
    }
  },
  watch: {
    fullHeight (val) {
      if (!this.timer) {
        this.fullHeight = val
        this.timer = true
        let that = this
        setTimeout(function () {
          that.timer = false
        }, 400)
      }
    },
    screenWidth (val) {
      this.screenWidth = val;
      this.controlerShow = false
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true
        let that = this
        setTimeout(function () {
          that.timer = false
        }, 400)
      }
    }
  }
}
</script>
<style lang="scss">
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading {
  // position: relative;
  .loader {
    width: 108px;
    height: 108px;
    background: rgba(15, 16, 17, 0.3);
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .ball-clip-rotate {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      > div {
        width: 40px;
        height: 40px;
        border-radius: 100%;
        margin: 2px;
        animation-fill-mode: both;

        border: 2px solid #fff;
        border-bottom-color: transparent;
        background: transparent !important;
        display: inline-block;
        animation: rotate 0.75s 0s linear infinite;
      }
    }
  }
}
.play {
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  .opacityBtn {
    height: 13%;
    display: flex;
    background: rgba($color: #000000, $alpha: 0.6);
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    background-color: #000;
    .slider {
      width: 80%;
      margin: 0 15px;
      .el-slider__runway {
        height: 4px;
      }
      .el-slider__bar {
        background-color: #fd9552;
        height: 4px;
      }
      .el-slider__button {
        background-color: #fd9552;
        width: 20px;
        height: 20px;
        border: 2px solid #ffffff;
      }
      .el-slider__button-wrapper {
        // height: 1px;
        top: -32px;
      }
    }
    .text {
      font-size: 12px;
      font-family: 'Source Han Sans CN';
      font-weight: 400;
      color: #ffffff;
      opacity: 1;
    }
    .opacityValue {
      width: 100px;
      font-size: 12px;
      font-family: 'Source Han Sans CN';
      font-weight: 400;
      color: #ffffff;
      opacity: 1;
    }
  }
  .myvideo {
    width: 100%;
    height: 87%;
  }
  .videoTitle {
    height: 36px;
    font-size: 36px;
    font-family: 'Source Han Sans CN';
    font-weight: bold;
    color: #101010;
    opacity: 1;
  }
}
.video {
  background: #ffffff;
  display: flex;
  .myvideo.fullscreen {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
  }
  .myvideo {
    // width: 1353px;
    // height: 872px;
    position: relative;
    video {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
    .videoPlay {
      position: absolute;
      z-index: 10;
      width: 90%;
      left: 0;
      right: 0;
      bottom: 32px;
      margin: 0 auto;
      color: #ffffff;
      img {
        width: 64px;
        height: 64px;
      }
      .myprogress {
        margin-bottom: 16px;
      }
      .controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          display: flex;
          align-items: center;
          position: relative;
          img {
            margin-right: 24px;
          }
          .bofang {
            position: relative;
            .block {
              width: 60px;
              display: flex;
              flex-direction: column;
              align-items: center;
              position: absolute;
              bottom: 67px;
              left: -7px;
              background: rgba(0, 0, 0, 0.5);
              padding: 12px 0 10px 0;
              border-radius: 10px;
              .el-slider__runway {
                height: 200px !important;
                width: 10px;
              }
              .box {
                font-size: 12px;
                margin-bottom: 10px;
              }
              .el-slider__button {
                width: 0px;
                height: 0px;
                border: 0px;
              }
              .el-slider__bar {
                background-color: #ffffff;
                width: 10px;
              }
              .el-slider__runway {
                background: #88898b;
              }
            }
          }
        }
      }
    }
  }
  .videoTitle {
    height: 36px;
    font-size: 36px;
    font-family: 'Source Han Sans CN';
    font-weight: bold;
    color: #101010;
    opacity: 1;
  }
  .videoInfo {
    display: flex;
    justify-content: space-between;
    width: 1353px;
    .videoTitle {
      height: 36px;
      font-size: 36px;
      font-family: 'Source Han Sans CN';
      font-weight: bold;
      color: #101010;
      opacity: 1;
    }
  }
}
</style>